import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=e42d6ba4&scoped=true"
import script from "@/views/Settings/Materials/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Materials/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Materials/create-dialog.scss?vue&type=style&index=0&id=e42d6ba4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42d6ba4",
  null
  
)

export default component.exports